import React from 'react';
import type { ChangeCalendarLayout as ChangeCalendarType } from '@atlassian/jira-spa-apps-servicedesk-change-calendar/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyChangeCalendar = lazyForPaint<typeof ChangeCalendarType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-change-calendar", jiraSpaEntry: "async-servicedesk-change-calendar" */ '@atlassian/jira-spa-apps-servicedesk-change-calendar'
		),
	),
);

const AsyncChangeCalendar = (): React.JSX.Element => (
	<LazyPage
		Page={LazyChangeCalendar}
		pageId="spa-apps/servicedesk/change-calendar"
		shouldShowSpinner
	/>
);

export default AsyncChangeCalendar;
